import React from 'react'
import { Container } from 'reactstrap'
import { SearchBox } from 'react-instantsearch/dom'
import styled from 'styled-components'
import { Theme, SearchIconBlue } from '@pga/pga-component-library'

import LocationFilter from '../SearchFilters/LocationFilter'
import { StyledInputWrapper, StyledLocationInputWrapper, MainWrapper } from '../Dashboard/SearchForm/styles'

export const StyledSearchBox = styled(SearchBox)`
  height: 100%;
  width: 100%;
  border: none;
  
  .ais-SearchBox-form {
    height: 100%;
  }
  .ais-SearchBox-input {
    color: ${Theme.colors.primary};
    font-family: ${Theme.fonts.Montserrat};
    padding: 0.3rem 3rem;
    border: none;
    outline: none;
    height: 100%;
    width: 100%;
    font-size: 16px;
    font-weight: 400;
    border-radius: 4px;
  }
  .ais-SearchBox-reset {
    padding: 1rem;
  }
`

const SearchFormContainer = styled(Container)`
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  @media(min-width: 576px) {
    padding: 0;
  }
  @media(min-width: 576px) and (max-width: 991.98px) {
    max-width: 95%;
  }
`

export const SearchForm = ({ searchState, onSearchStateChange }) => (
  <SearchFormContainer>
    <MainWrapper>
      <StyledInputWrapper fw>
        <StyledSearchBox
          submit={<SearchIconBlue />}
          translations={{
            placeholder: 'Job Title, Keywords'
          }}
        />
      </StyledInputWrapper>
      <StyledLocationInputWrapper fw>
        <LocationFilter
          searchState={searchState}
          onSearchStateChange={onSearchStateChange}
        />
      </StyledLocationInputWrapper>
    </MainWrapper>
  </SearchFormContainer>
)

export default SearchForm
